import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="journey" className="py-24 bg-cream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-teal text-sm font-bold uppercase tracking-[0.18em]">{t.journey.kicker}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-ink font-heading leading-tight">
            {t.journey.title}{' '}
            <span className="font-accent italic text-teal font-normal">{t.journey.titleAccent}</span>
          </h2>
          <p className="mt-5 text-lg text-muted leading-relaxed">{t.journey.intro}</p>
        </div>

        <div className="relative">
          <div
            className="hidden lg:block absolute left-[2.65rem] top-8 bottom-8 w-0.5 bg-line"
            aria-hidden
          />

          <div className="space-y-6 lg:space-y-0">
            {t.journey.steps.map((step, index) => (
              <div
                key={step.num}
                className={`lg:flex lg:items-start lg:gap-10 ${
                  index % 2 === 1 ? 'lg:flex-row-reverse lg:text-right' : ''
                }`}
              >
                <div className="hidden lg:flex flex-col items-center shrink-0 w-[5.3rem]">
                  <div
                    className="w-14 h-14 bg-teal text-white font-extrabold text-lg flex items-center justify-center shadow-card z-10"
                    style={{ borderRadius: '14px' }}
                  >
                    {step.num}
                  </div>
                </div>

                <div
                  className={`flex-1 bg-surface border border-line p-8 hover:shadow-soft transition-shadow lg:mb-10 ${
                    index % 2 === 1 ? 'lg:mr-auto lg:max-w-md' : 'lg:ml-auto lg:max-w-md'
                  }`}
                  style={{ borderRadius: '1.25rem' }}
                >
                  <span className="lg:hidden text-teal font-extrabold text-sm">{step.num}</span>
                  <h3 className="text-xl font-bold text-ink mt-1 lg:mt-0 mb-2 font-heading">{step.title}</h3>
                  <p className="text-muted leading-relaxed text-sm">{step.description}</p>
                </div>

                <div className="hidden lg:block flex-1" aria-hidden />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
